import { render, staticRenderFns } from "./OrderTasks.vue?vue&type=template&id=9e185e44&scoped=true"
import script from "./OrderTasks.vue?vue&type=script&lang=js"
export * from "./OrderTasks.vue?vue&type=script&lang=js"
import style0 from "./OrderTasks.vue?vue&type=style&index=0&id=9e185e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e185e44",
  null
  
)

export default component.exports